// FileUploadDropzone.js
import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  Box,
  Typography,
  Button,
  Paper,
  LinearProgress
} from '@mui/material';
import Upload from '../assests/upload.png'; // Replace with correct path

const FileUploadDropzone = ({ onFileUpload }) => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadedFile, setUploadedFile] = useState(null);

  const simulateUpload = (file) => {
    setUploadProgress(0);
    const interval = setInterval(() => {
      setUploadProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setUploadedFile(file); // Only simulating one file
          return 100;
        }
        return prev + 10;
      });
    }, 100);
  };

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      simulateUpload(acceptedFiles[0]); // Simulate uploading the first file only
      onFileUpload && onFileUpload(acceptedFiles); // Pass all files to parent
    }
  }, [onFileUpload]);

  const { getRootProps, getInputProps, isDragActive, open } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/png': ['.png'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    },
    multiple: true,
    noClick: true, // prevents opening dialog on dropzone click
  });

  return (
    <>
      <Paper
        variant="outlined"
        {...getRootProps()}
        sx={{
          p: 4,
          borderRadius: '4px',
          backgroundColor: '#E7F2F8',
          textAlign: 'center',
          cursor: 'pointer'
        }}
      >
        <input {...getInputProps()} />
        <div className="flex justify-center items-center">
          <img src={Upload} alt="Upload" />
        </div>
        <Typography variant="body1" sx={{ mt: 2 }}>
          {isDragActive
            ? 'Drop the files here ...'
            : 'Drag and drop files here'}
        </Typography>
        <Typography variant="caption" sx={{ mt: 2, fontWeight:"bold" }}>
          Accepted Formats - PDF,JPG,PNG,JPEG
        </Typography>
        <Box mt={2}>
          <Button
            variant="contained"
            onClick={open}
            sx={{ backgroundColor: '#1381B5' }}
          >
            Browse Files
          </Button>
        </Box>
      </Paper>

      {uploadProgress > 0 && uploadProgress < 100 && (
        <Box mt={2}>
          <LinearProgress variant="determinate" value={uploadProgress} />
          <Typography variant="caption">{uploadProgress}%</Typography>
        </Box>
      )}
    </>
  );
};

export default FileUploadDropzone;
